import rambleWordmarkWhite from "./ramble-wordmark-white.svg?url"

export default {
  src: rambleWordmarkWhite,
  width: 599,
  height: 105,
}
